/***
 * Model that represents an PersonalRecordType
 */
import Backbone from 'backbone';

var PersonalRecordType = Backbone.Model.extend({
    initialize: function(args) {},

    /**
     * Sort collection in descending order by date badge was awarded
     */
    comparator: function(pr) {
        var key = pr.get('key');
        return key;
    },

    /**
     * Handle irregular URL mapping (relative to collection resource)
     **/
    urlRoot: '/personalrecord-service/personalrecordtype',
    backend: 'gcapi'
});

export default PersonalRecordType;
